import { createFileRoute } from '@tanstack/react-router'

interface IEmailLogSearch {
  page?: number
}

export const Route = createFileRoute('/_authenticated/email-log')({
  staticData: { title: 'Email log' },
  validateSearch: (search: Record<string, unknown>): IEmailLogSearch => ({
    page: Number(search.page) > 1 ? Number(search.page) : undefined,
  }),
})
